import React from 'react';

export const LoadingSpinner = ({ style }) => <img
  src="https://files.peakd.com/file/peakd-hive/cryptoshots.nft/AJivNTpHMfVCKpSc45YxXD2wCXRajhPRUcfVPB5N71AnNLWb4TVMsNS8FWkByhM.gif"
  style={{ border: 'thin solid white', ...style }}
  width={'80'}
  alt="loading.."
/>;
